var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FacebookIcon, InstagramIcon, NNBrandIcon, XTwitterIcon, YouTubeIcon, } from '@marketing-icons';
import Heading from '@marketing/components/global/typography/Heading';
import { Link } from 'react-router';
import MenuItemList from '../MenuItemList';
var productLinks = [
    {
        displayName: 'Our Meals',
        url: '/meals',
    },
    {
        displayName: 'Other Products',
        url: '/other-products',
    },
    {
        displayName: 'Subscribe',
        url: '/profile',
    },
    {
        displayName: 'Find in Store',
        url: '/retail',
    },
    {
        displayName: 'Sampler Pack',
        url: '/meals/sampler-pack',
    },
];
var aboutUsLinks = [
    {
        displayName: 'Why Nom Nom',
        url: '/why-nom-nom',
    },
    {
        displayName: 'How It Works',
        url: '/how-it-works',
    },
    {
        displayName: 'Our Team',
        url: '/team',
    },
    {
        displayName: 'Nom Nom Press',
        url: '/press',
    },
    {
        displayName: 'Careers',
        url: '/careers',
    },
];
var connectLinks = [
    {
        displayName: 'Contact Us',
        url: 'https://support.nomnomnow.com/hc/en-us/requests/new',
        isExternalLink: true,
    },
    {
        displayName: 'Affiliate Community',
        url: '/affiliate',
    },
    {
        displayName: 'Refer a Friend',
        url: '/account/invite',
        isExternalLink: true,
    },
];
var resourceLinks = [
    {
        displayName: 'Help Center',
        url: 'https://support.nomnomnow.com/hc/en-us',
        isExternalLink: true,
    },
    {
        displayName: 'FAQ Library',
        url: '/faq',
    },
    {
        displayName: 'Nom Nom Blog',
        url: '/learn',
    },
];
var policyLinks = [
    {
        displayName: 'Terms of Service',
        url: '/tos',
    },
    {
        displayName: 'Messaging Terms',
        url: '/messaging-terms',
    },
    {
        displayName: 'Privacy Policy',
        url: 'https://www.mars.com/privacy',
        isExternalLink: true,
    },
    {
        displayName: 'Accessibility',
        url: '/accessibility',
    },
    {
        displayName: 'Your Privacy Rights',
        url: '/opt-out',
    },
    {
        displayName: 'Cookies Notice',
        url: 'https://www.mars.com/privacy#cookies',
        isExternalLink: true,
    },
    {
        displayName: 'Cookies Settings',
        id: 'cookie-settings',
        className: 'ot-sdk-show-settings',
        url: '#cookie-settings',
    },
    {
        displayName: 'AdChoices',
        url: 'https://www.mars.com/mars-incorporated-adchoices-united-states',
        isExternalLink: true,
    },
];
function Footer() {
    return (_jsx("footer", __assign({ className: "w-full bg-surface-black" }, { children: _jsxs("div", __assign({ className: "w-full px-5 py-8 md:px-10 md:py-15 md:max-w-2xl mx-auto grid grid-cols-1 gap-15" }, { children: [_jsxs("div", __assign({ className: "grid grid-cols-1 lg:grid-cols-2 gap-y-8 md:gap-x-4" }, { children: [_jsx("div", __assign({ className: "w-[102px] md:w-[254px] h-[69px] md:h-[171px] shrink-0" }, { children: _jsx(Link, __assign({ to: "/", viewTransition: true }, { children: _jsx(NNBrandIcon, { className: "text-icon-white h-full w-full" }) })) })), _jsxs("div", __assign({ className: "grid grid-cols-2 lg:grid-cols-4 gap-x-3 gap-y-15" }, { children: [_jsxs("div", { children: [_jsx(Heading, __assign({ size: "sm", className: "font-sans uppercase !text-overline-nav-d !text-bone !mb-sm-gutter md:!mb-2xs-gutter" }, { children: "Products" })), _jsx(MenuItemList, { className: "gap-y-sm-m text-sm-reg-m md:text-sm-reg-d text-bone", listStyles: "gap-y-sm-m md:gap-y-2xs-m", menuItems: productLinks })] }), _jsxs("div", { children: [_jsx(Heading, __assign({ size: "sm", className: "!font-sans uppercase !text-overline-nav-d !mb-sm-gutter md:!mb-2xs-gutter text-bone" }, { children: "About Us" })), _jsx(MenuItemList, { className: "text-sm-reg-m md:text-sm-reg-d text-bone", listStyles: "gap-y-sm-m md:gap-y-2xs-m", menuItems: aboutUsLinks })] }), _jsxs("div", { children: [_jsx(Heading, __assign({ size: "sm", className: "!font-sans uppercase !text-overline-nav-d !text-bone !mb-sm-gutter md:!mb-2xs-gutter" }, { children: "Connect" })), _jsx(MenuItemList, { className: "text-sm-reg-m md:text-sm-reg-d text-bone", listStyles: "gap-y-sm-m md:gap-y-2xs-m", menuItems: connectLinks })] }), _jsxs("div", { children: [_jsx(Heading, __assign({ size: "sm", className: "!font-sans uppercase !text-overline-nav-d !text-bone !mb-sm-gutter md:!mb-2xs-gutter" }, { children: "Resources" })), _jsx(MenuItemList, { className: "text-sm-reg-m text-bone md:text-sm-reg-d ", listStyles: "gap-y-sm-m md:gap-y-2xs-m", menuItems: resourceLinks })] })] }))] })), _jsxs("div", __assign({ className: "grid grid-cols-1 gap-8 md:gap-15" }, { children: [_jsx("div", __assign({ className: "flex flex-col justify-start items-start gap-sm-gutter md:gap-lg-gutter w-full" }, { children: _jsxs("div", __assign({ className: "flex justify-start items-center gap-sm-m" }, { children: [_jsx("a", __assign({ href: "https://trynom.com/facebook", target: "_blank", rel: "noopener noreferrer" }, { children: _jsx(FacebookIcon, {}) })), _jsx("a", __assign({ href: "https://trynom.com/instagram", target: "_blank", rel: "noopener noreferrer" }, { children: _jsx(InstagramIcon, {}) })), _jsx("a", __assign({ href: "https://trynom.com/twitter", target: "_blank", rel: "noopener noreferrer" }, { children: _jsx(XTwitterIcon, {}) })), _jsx("a", __assign({ href: "https://trynom.com/youtube", target: "_blank", rel: "noopener noreferrer" }, { children: _jsx(YouTubeIcon, {}) }))] })) })), _jsxs("div", __assign({ className: "grid grid-cols-1 xl:grid-cols-2 gap-y-8 md:gap-x-4" }, { children: [_jsx("div", __assign({ className: "text-bone" }, { children: "\u00A92025 Nom Nom Now, Inc. NomNomNow is a registered trademark." })), _jsx("div", __assign({ className: "flex justify-start items-start w-full md:!w-[640px] shrink-0" }, { children: _jsx(MenuItemList, { className: "text-sm-reg-m md:text-sm-reg-d w-full h-[150px] md:h-[100px] text-bone", listStyles: "flex-wrap md:flex-row gap-x-3 md:gap-x-0 md:gap-y-3", listItemStyles: "w-1/2 md:w-1/4", menuItems: policyLinks }) }))] }))] }))] })) })));
}
export default Footer;
